import React from 'react';
import ModuleRoute from 'holocron-module-route';
import requireAuth from './utils/requireAuth';
import selectProductRedirect from './utils/selectProductRedirect';
import SessionManager from './components/SessionManager';
import updateLocaleFromRoute from './utils/updateLocaleFromRoute';

const childRoutes = (store) => [
  <ModuleRoute moduleName="axp-page-wrapper" onEnter={updateLocaleFromRoute(store)}>
    <ModuleRoute component={SessionManager}>
      <ModuleRoute onEnter={selectProductRedirect(store)}>
        <ModuleRoute onEnter={requireAuth(store, undefined, true)}>
          <ModuleRoute path="(:locale/)account/document-centre" moduleName="axp-doc-center" />
          <ModuleRoute path="(:locale/)account/document-center" moduleName="axp-doc-center" />
          <ModuleRoute path="(:locale/)compte/centre-de-documentation" moduleName="axp-doc-center" />
          <ModuleRoute path="(:locale/konto/last-opp-dokument)" moduleName="axp-doc-center" />
          <ModuleRoute path="(:locale/tili/lataa-asiakirja)" moduleName="axp-doc-center" />
          <ModuleRoute path="(:locale/account/centre-document)" moduleName="axp-doc-center" />
          <ModuleRoute path="(:locale/account/documentenportaal)" moduleName="axp-doc-center" />
          <ModuleRoute path="(:locale/konto/ladda-upp-dokument)" moduleName="axp-doc-center" />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute path="demo/:moduleName" moduleName="axp-demo" />,
];
export default childRoutes;
